<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.carmwtwopassrecord_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/carv2/carmwtwopassrecord';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        column: [
          {
            label: '主键',
            prop: 'id',
            rules: [
              {
                required: true,
                message: '请输入主键',
                trigger: 'change',
              },
            ],
          },
          {
            label: '小区id',
            prop: 'areaId',
            rules: [
              {
                required: true,
                message: '请输入小区id',
                trigger: 'change',
              },
            ],
          },
          {
            label: '包ID',
            prop: 'pkgId',
            rules: [
              {
                required: true,
                message: '请输入包ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '记录平台编号',
            prop: 'recordPlatformNo',
            rules: [
              {
                required: true,
                message: '请输入记录平台编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '记录本地编号',
            prop: 'recordLocalNo',
            rules: [
              {
                required: true,
                message: '请输入记录本地编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '通道平台编号',
            prop: 'gatePlatformNo',
            rules: [
              {
                required: true,
                message: '请输入通道平台编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '通道本地编号',
            prop: 'gateLocalNo',
            rules: [
              {
                required: true,
                message: '请输入通道本地编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '规则平台编号',
            prop: 'accessPlatformNo',
            rules: [
              {
                required: true,
                message: '请输入规则平台编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '规则本地编号',
            prop: 'accessLocalNo',
            rules: [
              {
                required: true,
                message: '请输入规则本地编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '开闸平台编号',
            prop: 'openPlatformNo',
            rules: [
              {
                required: true,
                message: '请输入开闸平台编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '开闸本地编号',
            prop: 'openLocalNo',
            rules: [
              {
                required: true,
                message: '请输入开闸本地编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '入场记录平台编号  出入记录关联冗余',
            prop: 'enterPlatformNo',
            rules: [
              {
                required: true,
                message: '请输入入场记录平台编号  出入记录关联冗余',
                trigger: 'change',
              },
            ],
          },
          {
            label: '入场记录本地编号  出入记录关联冗余',
            prop: 'enterLocalNo',
            rules: [
              {
                required: true,
                message: '请输入入场记录本地编号  出入记录关联冗余',
                trigger: 'change',
              },
            ],
          },
          {
            label: '记录类型：1：终端记录 2：手工录入',
            prop: 'recordType',
            rules: [
              {
                required: true,
                message: '请输入记录类型：1：终端记录 2：手工录入',
                trigger: 'change',
              },
            ],
          },
          {
            label: '通行类型：1：入场 2：出场',
            prop: 'passType',
            rules: [
              {
                required: true,
                message: '请输入通行类型：1：入场 2：出场',
                trigger: 'change',
              },
            ],
          },
          {
            label:
              '通行方式：10：自动识别（正常）；20：人工验证（正常）；21：人工验证（未识别）；30：自助验证（无牌车）;99：其它方式',
            prop: 'passMode',
            rules: [
              {
                required: true,
                message:
                  '请输入通行方式：10：自动识别（正常）；20：人工验证（正常）；21：人工验证（未识别）；30：自助验证（无牌车）;99：其它方式',
                trigger: 'change',
              },
            ],
          },
          {
            label:
              '车辆类型：1：临时车辆 2：月租车辆 3：储值车辆  4：VIP车辆 5：会员车辆 9：其他车辆',
            prop: 'vehicleType',
            rules: [
              {
                required: true,
                message:
                  '请输入车辆类型：1：临时车辆 2：月租车辆 3：储值车辆  4：VIP车辆 5：会员车辆 9：其他车辆',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车辆平台编号 固定车辆关联冗余',
            prop: 'vehiclePlatformNo',
            rules: [
              {
                required: true,
                message: '请输入车辆平台编号 固定车辆关联冗余',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车辆本地编号 固定车辆关联冗余',
            prop: 'vehicleLocalNo',
            rules: [
              {
                required: true,
                message: '请输入车辆本地编号 固定车辆关联冗余',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车辆颜色',
            prop: 'vehicleColor',
            rules: [
              {
                required: true,
                message: '请输入车辆颜色',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车牌颜色',
            prop: 'plateColor',
            rules: [
              {
                required: true,
                message: '请输入车牌颜色',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车牌号码',
            prop: 'plateNumber',
            rules: [
              {
                required: true,
                message: '请输入车牌号码',
                trigger: 'change',
              },
            ],
          },
          {
            label: '识别号码（容错）',
            prop: 'recognizeNumber',
            rules: [
              {
                required: true,
                message: '请输入识别号码（容错）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '识别率',
            prop: 'recognizeRate',
            rules: [
              {
                required: true,
                message: '请输入识别率',
                trigger: 'change',
              },
            ],
          },
          {
            label: '识别车牌位置，左',
            prop: 'recognizeLeft',
            rules: [
              {
                required: true,
                message: '请输入识别车牌位置，左',
                trigger: 'change',
              },
            ],
          },
          {
            label: '识别车牌位置，右',
            prop: 'recognizeRight',
            rules: [
              {
                required: true,
                message: '请输入识别车牌位置，右',
                trigger: 'change',
              },
            ],
          },
          {
            label: '识别车牌位置，上',
            prop: 'recognizeTop',
            rules: [
              {
                required: true,
                message: '请输入识别车牌位置，上',
                trigger: 'change',
              },
            ],
          },
          {
            label: '识别车牌位置，下',
            prop: 'recognizeBottom',
            rules: [
              {
                required: true,
                message: '请输入识别车牌位置，下',
                trigger: 'change',
              },
            ],
          },
          {
            label: '记录备注',
            prop: 'recordDesc',
            rules: [
              {
                required: true,
                message: '请输入记录备注',
                trigger: 'change',
              },
            ],
          },
          {
            label: '更新人ID，预留',
            prop: 'updateUserId',
            rules: [
              {
                required: true,
                message: '请输入更新人ID，预留',
                trigger: 'change',
              },
            ],
          },
          {
            label: '更新人名称，预留',
            prop: 'updateUserName',
            rules: [
              {
                required: true,
                message: '请输入更新人名称，预留',
                trigger: 'change',
              },
            ],
          },
          {
            label: 'job是否同步：0没有同步 1.已经同步',
            prop: 'jobSync',
            rules: [
              {
                required: true,
                message: '请输入job是否同步：0没有同步 1.已经同步',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.carmwtwopassrecord_add, false),
        viewBtn: this.vaildData(this.permission.carmwtwopassrecord_view, false),
        delBtn: this.vaildData(this.permission.carmwtwopassrecord_delete, false),
        editBtn: this.vaildData(this.permission.carmwtwopassrecord_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
